import React from "react";
import introImg from "../../images/info-green.svg";


export const StatsCard = (props) => {
  const {title, label, qty, color, source, image} = props;
  
  
  return (
    <div
      className="zg-card-stat d-flex flex-column align-items-start height-100 border rounded-4">
      <div className="d-flex letter-spacing-1 flex-column mb-lg-0 mb-md-6 mb-4">
        <div className="d-flex align-items-start text-black">
          <span className={`bg-${color} fs-8 p-2 mb-3 align-self-start`}>{title}</span>
          <span className={`zg-label ms-2 bg-${color}`}>{label}</span>
        </div>
        <span className="fw-bolder fs-4">{qty}
        <div className='tooltip'> 
        <img src={image.localFile.publicURL} className="info-img" alt="info icon" width="25" height="25" loading="lazy"/>
        <span  className="tooltiptext">         
        {source && (
          <div className="mb-0 mt-2" dangerouslySetInnerHTML={{__html: source}}></div>
        )} 
        </span>
        </div>
        </span>
      </div>
    </div>
  )
}
